import constants from "../../../../appConstants";
import { MultiSelectFilter, DateTimeFilter } from "../../../dataGrid/columnFilters";
import { formatDayWindow, getDefaultHours, renderWindow } from "../EditCustomer/utils";
import {
  GeoCodeRenderer,
  SpecialNeedsValueGetter,
  SpecialNeedsRenderer,
} from "../../../dataGrid/cellRenderer";
import { StaticFilter } from "../../../dataGrid/columnFilters";
import iconRenderer from "../../../common/iconRenderer";

class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration();
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getTrailerSwapValue = (params) => {
    return params.data.pickupDetails.isTrailerSwap ? "Yes" : "";
  }


  static getLocal = (params) => {
    return params.data.pickupDetails.isLocal ? "Yes" : "";
  }

  static getSpecialNeedsOption(params) {
    return params.context.specialNeedsOptions;
  }

  static specialNeedsValueGetter(params) {
    return SpecialNeedsValueGetter({
      data: {
        shipperComments: params.data?.pickupDetails?.shipperComments,
        isDelivery: false,
      },
    });
  }

  static getDefaultConfiguration() {
    return {
      title: constants.gridNames.ShipperGrid,
      keyColumn: "code",
      rowSelection: "multiple",
      rowDeselection: "true",
      enableFilters: false,
      enableSorting: false,
      defaultColDef: {
        lockPinned: true,
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Acc #",
          headerTooltip: "Shipper Account Number",
          field: "code",
          minWidth: constants.columnWidth.CUSTOMER_CODE,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          tooltipField: "code",
          lockPosition: true,
        },
        {
          headerName: "Shipper Name",
          headerTooltip: "Shipper Name",
          field: "name",
          minWidth: constants.columnWidth.W_180,
          lockPosition: true,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          tooltipField: "name",
        },
        {
          headerName: "Spl Needs",
          headerTooltip: "Special Needs",
          minWidth: constants.columnWidth.SPL_NEED,
          cellClass: "gridCell-leftAlign",
          valueGetter: GridConfig.specialNeedsValueGetter,
          filterFramework: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getSpecialNeedsOption,
          },
          cellRendererFramework: SpecialNeedsRenderer,
        },
        {
          headerName: "Address",
          headerTooltip: "Shipper Address",
          field: "address",
          minWidth: constants.columnWidth.CUSTOMER_ADDRESS,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          tooltipField: "address",
        },
        {
          headerName: "City",
          headerTooltip: "City",
          field: "city",
          cellClass: "gridCell-leftAlign",
          minWidth: constants.columnWidth.CITY,
          filterFramework: MultiSelectFilter,
          tooltipField: "city",
        },
        {
          headerName: "State",
          headerTooltip: "State",
          field: "state",
          cellClass: "gridCell-leftAlign",
          minWidth: constants.columnWidth.STATE,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Zip",
          headerTooltip: "Zip",
          field: "zip",
          cellClass: "gridCell-leftAlign",
          minWidth: constants.columnWidth.ZIP_CODE,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Geocoding",
          headerTooltip: "Geocoding",
          field: "pickupDetails.isGeoCoded",
          minWidth: constants.columnWidth.GEOCODING,
          cellClass: "gridCell-left,Align",
          editable: false,
          cellRendererFramework: GeoCodeRenderer,
          filterFramework: StaticFilter,
          filterParams: {
            staticOptions: Object.values(constants.geoCode),
            renderIcon: iconRenderer,
          },
        },
        {
          headerName: "Trailer Swap",
          headerTooltip: "Trailer Swap",
          field: "pickupDetails.isTrailerSwap",
          valueGetter: GridConfig.getTrailerSwapValue,
          minWidth: constants.columnWidth.W_115,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Local Shipper",
          headerTooltip: "Is Local Shipper",
          field: "deliveryDetails.isLocal",
          valueGetter: GridConfig.getLocal,
          minWidth: constants.columnWidth.W_125,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Default Hours",
          headerTooltip: "Default Hours",
          valueGetter: getDefaultHours,
          minWidth: constants.columnWidth.W_140,
          cellClass: "gridCell-leftAlign",
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isTimeInterval: true,
            useGetterValue: true,
          },
        },
        {
          headerName: "Monday",
          headerTooltip: "Monday",
          field: "pickupDetails.shippingHours.monday",
          tooltipField: "pickupDetails.shippingHours.monday",
          valueFormatter: formatDayWindow,
          minWidth: constants.columnWidth.W_140,
          cellClass: "gridCell-leftAlign",
          cellRendererFramework: renderWindow,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isTimeInterval: true,
            useGetterValue: true,
          },
        },
        {
          headerName: "Tuesday",
          headerTooltip: "Tuesday",
          field: "pickupDetails.shippingHours.tuesday",
          tooltipField: "pickupDetails.shippingHours.tuesday",
          valueFormatter: formatDayWindow,
          minWidth: constants.columnWidth.W_140,
          cellClass: "gridCell-leftAlign",
          cellRendererFramework: renderWindow,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isTimeInterval: true,
            useGetterValue: true,
          },
        },
        {
          headerName: "Wednesday",
          headerTooltip: "Wednesday",
          field: "pickupDetails.shippingHours.wednesday",
          tooltipField: "pickupDetails.shippingHours.wednesday",
          valueFormatter: formatDayWindow,
          minWidth: constants.columnWidth.W_140,
          cellClass: "gridCell-leftAlign",
          cellRendererFramework: renderWindow,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isTimeInterval: true,
            useGetterValue: true,
          },
        },
        {
          headerName: "Thursday",
          headerTooltip: "Thursday",
          field: "pickupDetails.shippingHours.thursday",
          tooltipField: "pickupDetails.shippingHours.thursday",
          valueFormatter: formatDayWindow,
          minWidth: constants.columnWidth.W_140,
          cellClass: "gridCell-leftAlign",
          cellRendererFramework: renderWindow,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isTimeInterval: true,
            useGetterValue: true,
          },
        },
        {
          headerName: "Friday",
          headerTooltip: "Friday",
          field: "pickupDetails.shippingHours.friday",
          tooltipField: "pickupDetails.shippingHours.friday",
          valueFormatter: formatDayWindow,
          minWidth: constants.columnWidth.W_140,
          cellClass: "gridCell-leftAlign",
          cellRendererFramework: renderWindow,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isTimeInterval: true,
            useGetterValue: true,
          },
        },
        {
          headerName: "Arrive Early (mins)",
          headerTooltip: "Arrive Early (mins)",
          field: "pickupDetails.appointmentBufferStart",
          minWidth: constants.columnWidth.W_150,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Arrive Late (mins)",
          headerTooltip: "Arrive Late (mins)",
          field: "pickupDetails.appointmentBufferEnd",
          minWidth: constants.columnWidth.W_150,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
      ],
    };
  }
}

export default GridConfig;
